// extracted by mini-css-extract-plugin
export default {"container":"MVS_container__XtuGI","lerDados":"MVS_lerDados__Yph3i","buttons":"MVS_buttons__y6kpH","tabela":"MVS_tabela__VGiN1"};